var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L8,5 L0,5 L4,0 Z",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,9 L4,14 L8.8817842e-16,9",
    fill: "#3C3C3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingDesc);
export default __webpack_public_path__ + "static/media/sortingDesc.bb51d9c489b081952da3730c96f5c0aa.svg";
export { ForwardRef as ReactComponent };